import { SortOrder } from '../constants'

import type { FunctionalComponent } from 'vue'

export type SortIconProps = {
  sortOrder: SortOrder
  class?: JSX.IntrinsicAttributes['class']
}

const SortIcon: FunctionalComponent<SortIconProps> = (props) => {
  const { sortOrder } = props
  const classTag =
    sortOrder === SortOrder.ASC
      ? 'ascending'
      : sortOrder === SortOrder.DESC
      ? 'descending'
      : ''

  return (
    <span class={`caret-wrapper ${classTag}`}>
      <i class={'sort-caret ascending'} />
      <i class={'sort-caret descending'} />
    </span>
  )
}

export default SortIcon
